"use client";

import Image from "next/image";
import Link from "next/link";
import { motion } from "framer-motion";
import { useTranslation } from "react-i18next";

export default function CManagerCard() {
  const { t } = useTranslation("info");

  return (
    <motion.div
      initial={{ opacity: 0, y: 10 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5, delay: 0.4 }}
      className=" bg-white rounded-lg border border-gray-100 shadow-sm p-4 flex items-center gap-4"
    >
      {/* Stefania */}
      <div className="flex-shrink-0 w-[60px] h-[60px] rounded-full overflow-hidden">
        <Image
          src="/team/stefania.jpg"
          alt="Stefania Manzo"
          width={60}
          height={60}
          className="w-full h-full object-cover"
        />
      </div>

      <div>
        <h3 className="text-lg font-semibold text-gray-900">Stefania Manzo</h3>
        <p className="text-sm text-gray-500">{t("cManagerCard.role")}</p>
        <Link
          href="https://cal.com/stefania-manzo/15min"
          className="text-sm text-primary underline cursor-pointer mt-1 select-none"
        >
          {t("cManagerCard.contactButton")}
        </Link>
      </div>
    </motion.div>
  );
}
